import classNames from "classnames";
import React from "react";

interface Props {
  label: JSX.Element | string
  subLabel?: string
  link?: string
  error?: boolean
}

const SmallDetails = (props: Props) => {
  const { label, subLabel, link, error } = props;

  const parentClassName = classNames({ "red": error });
  const sublabelClassName = classNames("text-sublabel", { "red": error });

  return <div className={parentClassName}>
    {link ? <a href={link}>{label}</a> : label}
    {subLabel && <div className={sublabelClassName}>
      {subLabel}
    </div>}
  </div>;
};

export default SmallDetails;